import { Controller } from "@hotwired/stimulus";

// Toggles a hidden panel and swaps open/close label text.
// Usage:
//   data-controller="disclosure"
//   data-action="disclosure#toggle" on the button
//   data-disclosure-target="panel"      on the collapsible element
//   data-disclosure-target="openLabel"  text shown when closed
//   data-disclosure-target="closeLabel" text shown when open
export default class DisclosureController extends Controller {
  static targets = ["panel", "openLabel", "closeLabel"];

  toggle() {
    const open = this.panelTarget.classList.toggle("hidden");
    // open === true means we just added "hidden" → panel is now closed
    this.openLabelTargets.forEach((el) => el.classList.toggle("hidden", !open));
    this.closeLabelTargets.forEach((el) => el.classList.toggle("hidden", open));
  }
}
